(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('loading', function($interval, $interpolate) {
    return {
        restrict: 'A',
        scope: {
            loading: '=',
            hide: '@'
        },
        link(scope, el, attr) {
            const val = el.text();
            const hide = attr.hide === 'true';
            let p = null;
            let i = 0;
            let dots = '';

            function reset() {
                $interval.cancel(p);
                el.text($interpolate(val)(scope.$parent));
                if (hide) {
                    el.hide();
                }
                i = 0;
            }

            scope.$watch('loading', function(v) {
                if (v) {
                    if (hide) {
                        el.show();
                    }
                    $interval.cancel(p);

                    p = $interval(function() {
                        dots = (i++ % 5 === 0) ? '' : `${dots}.`;
                        el.text($interpolate(val + dots)(scope.$parent));
                    }, 200);
                } else {
                    reset();
                }
            });

            scope.$on('$destroy', function() {
                reset();
            });
        }
    };
});
})();
